import React from 'react';

function NotyInfoIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="45"
      fill="none"
      viewBox="0 0 44 45"
    >
      <g>
        <path
          fill="#369FFF"
          d="M22 39.062c-9.167 0-16.5-7.516-16.5-16.5 0-8.983 7.517-16.5 16.5-16.5 9.167 0 16.5 7.517 16.5 16.5 0 8.984-7.333 16.5-16.5 16.5zm0-29.516c-6.967 0-12.833 5.866-12.833 12.833 0 6.967 5.866 12.833 12.833 12.833 6.967 0 12.833-5.866 12.833-12.833 0-6.967-5.683-12.833-12.833-12.833zm1.833 20.533v-8.433c0-1.1-.733-1.834-1.833-1.834s-1.833.734-1.833 1.834v8.433c0 1.1.733 1.833 1.833 1.833s1.833-.916 1.833-1.833zm0-14.85v-.55c0-1.1-.733-1.833-1.833-1.833s-1.833.733-1.833 1.833v.55c0 1.1.733 1.833 1.833 1.833s1.833-.733 1.833-1.833z"
        ></path>
      </g>
    </svg>
  );
}

export default NotyInfoIcon;
